import type { GetStaticProps } from 'next'
import { useEffect } from 'react'

import { BucketsPageVariant } from 'sections/gender-funnel/WelcomeAgeBuckets/BucketsPageVariant'
import { OnboardingVariant } from 'types/state'
import { getCommonStaticProps } from 'utils/get-common-static-props'
import { useDataState } from 'utils/state'

export const getStaticProps: GetStaticProps = async (context) => {
  return {
    props: {
      ...(await getCommonStaticProps(context)),
    },
  }
}

export default function WelcomePage() {
  const { set } = useDataState()

  useEffect(() => {
    set('common', {
      onboardingVariant: OnboardingVariant.Mixed,
    })
  }, [set])

  return <BucketsPageVariant funnel="shared" />
}
